import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-timer/jb-timer.css.ts
var jb_timer_css_default = i`div{font-family:var(--theme-font-bold-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-weight:var(--theme-font-bold-weight, 700)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}div{color:rgb(var(--theme-color-royal-blue, 20 30 85)/var(--theme-opacity-80, 0.8));font-size:.813rem}div.right-aligned{text-align:right}`;

export {
  jb_timer_css_default
};
